import {MarkdownMetaDataInterface} from "../../interfaces/MarkdownMetaDataInterface";
import HeaderImageWithHeading from "./HeaderImageWithHeading";
import SimpleMarkdownRenderer from "./SimpleMarkdownRenderer";

interface SimpleMarkdownPageWithHeaderProps {
	metadata: MarkdownMetaDataInterface,
	mdxFile: any
}

function SimpleMarkdownPageWithHeader(props: SimpleMarkdownPageWithHeaderProps) {

	const {metadata: result, mdxFile} = props;
	return (<><HeaderImageWithHeading imageSrc={result.metadata.metadata.image}
	                                  title={result.metadata.metadata.title}
	                                  subtitle={result.metadata.metadata.subtitle}
	                                  subtitle2={result.metadata.metadata.subtitle2}/>
		<div className="container mx-auto mt-20 max-w-[1000px] my-10">
			<div className="px-6 md:px-20">
				<SimpleMarkdownRenderer mdxFile={mdxFile}/>
			</div>
		</div>
	</>);
}

export default SimpleMarkdownPageWithHeader;